const BranchMange = () => {
    return (
        <svg width="280" height="177" viewBox="0 0 280 177" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M257.477 142.509C257.41 142.482 257.375 142.407 257.398 142.336C259.305 136.492 264.206 131.991 270.19 130.59C270.265 130.572 270.34 130.619 270.358 130.694C270.376 130.77 270.329 130.845 270.253 130.863C264.365 132.242 259.541 136.672 257.664 142.423C257.64 142.497 257.561 142.537 257.487 142.513L257.477 142.509Z"
                fill="#263238"
            />
            <path
                d="M262.175 138.76C260.853 137.667 258.761 139.48 258.793 139.544C258.645 139.799 258.503 140.058 258.367 140.322C258.658 140.054 259.617 139.902 260.878 140.184C262.138 140.417 263.473 139.755 262.175 138.76Z"
                fill="#263238"
            />
            <path
                d="M258.219 135.783C256.884 134.757 256.232 136.984 257.103 138.022C257.923 139.068 258.365 139.92 258.347 140.313C258.465 140.04 258.589 139.771 258.72 139.505C258.655 139.497 259.447 136.801 258.219 135.783Z"
                fill="#263238"
            />
            <path
                d="M263.871 136.866C262.751 135.569 260.401 136.982 260.423 137.047C260.236 137.27 260.055 137.497 259.879 137.73C260.208 137.521 261.173 137.541 262.365 138.036C263.565 138.485 264.983 138.066 263.871 136.866Z"
                fill="#263238"
            />
            <path
                d="M260.47 133.266C259.327 132.032 258.323 134.102 259.01 135.266C259.644 136.43 259.94 137.338 259.859 137.717C260.019 137.472 260.185 137.232 260.357 136.996C260.293 136.98 261.509 134.479 260.47 133.266Z"
                fill="#263238"
            />
            <path
                d="M265.853 135.283C264.964 133.819 262.419 134.813 262.431 134.878C262.212 135.065 261.996 135.257 261.785 135.455C262.142 135.307 263.087 135.492 264.178 136.181C265.283 136.827 266.748 136.652 265.853 135.283Z"
                fill="#263238"
            />
            <path
                d="M263.102 131.166C262.179 129.759 260.849 131.628 261.334 132.888C261.766 134.14 261.908 135.082 261.767 135.439C261.964 135.227 262.166 135.02 262.374 134.817C262.312 134.792 263.921 132.536 263.102 131.166Z"
                fill="#263238"
            />
            <path
                d="M268.073 134.058C267.44 132.466 264.761 133.023 264.764 133.089C264.516 133.236 264.272 133.39 264.031 133.549C264.407 133.463 265.308 133.803 266.268 134.665C267.248 135.487 268.725 135.558 268.073 134.058Z"
                fill="#263238"
            />
            <path
                d="M266.05 129.537C265.376 127.996 263.745 129.62 264.014 130.943C264.231 132.25 264.214 133.202 264.016 133.53C264.245 133.354 264.479 133.184 264.717 133.019C264.658 132.985 266.626 131.027 266.05 129.537Z"
                fill="#263238"
            />
            <path
                d="M270.488 133.215C270.131 131.538 267.375 131.644 267.369 131.709C267.099 131.814 266.831 131.925 266.566 132.042C266.953 132.019 267.786 132.505 268.59 133.515C269.42 134.488 270.877 134.804 270.488 133.215Z"
                fill="#263238"
            />
            <path
                d="M269.258 128.419C268.853 126.785 266.951 128.117 266.993 129.467C266.985 130.794 266.806 131.731 266.555 132.022C266.811 131.886 267.071 131.757 267.335 131.633C267.28 131.59 269.571 129.984 269.258 128.419Z"
                fill="#263238"
            />
            <path
                d="M268.934 131.077C268.895 131.054 270.974 129.655 272.329 129.434C273.653 129.178 274.159 130.112 273.94 130.659C273.729 131.212 272.8 131.352 272.012 131.306C271.237 131.197 268.945 131.037 268.934 131.077Z"
                fill="#263238"
            />
            <path
                d="M268.898 131.162C268.895 131.161 268.891 131.159 268.887 131.157C268.853 131.137 268.834 131.096 268.841 131.058C268.842 131.055 268.843 131.052 268.844 131.049C268.851 131.024 268.857 131.005 268.891 130.992C269.225 130.671 271.15 129.53 272.314 129.341C272.966 129.215 273.524 129.363 273.843 129.749C274.073 130.027 274.145 130.397 274.027 130.692C273.742 131.441 272.408 131.422 272.006 131.398C271.25 131.292 269.164 131.147 268.965 131.164C268.943 131.171 268.92 131.171 268.898 131.162ZM273.3 129.58C273.079 129.489 272.77 129.443 272.347 129.525C271.278 129.699 269.77 130.606 269.216 130.979C269.413 130.986 269.717 131.007 270.193 131.041C270.806 131.086 271.609 131.154 272.024 131.212C272.779 131.256 273.662 131.126 273.853 130.624C273.946 130.39 273.886 130.094 273.699 129.868C273.623 129.776 273.496 129.661 273.3 129.58Z"
                fill="#263238"
            />
            <path
                d="M257.581 142.399C257.515 142.43 257.436 142.405 257.4 142.34C254.415 136.966 254.453 130.311 257.498 124.973C257.536 124.906 257.622 124.882 257.689 124.921C257.756 124.959 257.78 125.045 257.741 125.112C254.745 130.365 254.708 136.915 257.645 142.204C257.683 142.272 257.658 142.357 257.591 142.394L257.581 142.399Z"
                fill="#263238"
            />
            <path
                d="M258.027 136.405C256.327 136.63 256.232 139.397 256.301 139.417C256.386 139.699 256.48 139.98 256.581 140.259C256.582 139.863 257.123 139.057 258.188 138.325C259.217 137.56 259.64 136.132 258.027 136.405Z"
                fill="#263238"
            />
            <path
                d="M253.151 137.278C251.491 137.558 252.679 139.551 254.033 139.619C255.356 139.731 256.282 139.987 256.557 140.267C256.438 139.995 256.325 139.72 256.22 139.444C256.169 139.486 254.733 137.072 253.151 137.278Z"
                fill="#263238"
            />
            <path
                d="M257.793 133.872C256.08 133.811 255.516 136.494 255.579 136.522C255.615 136.81 255.658 137.098 255.709 137.386C255.779 137.002 256.451 136.309 257.625 135.772C258.77 135.199 259.428 133.874 257.793 133.872Z"
                fill="#263238"
            />
            <path
                d="M252.84 133.914C251.157 133.912 251.991 136.057 253.311 136.345C254.596 136.672 255.463 137.074 255.685 137.391C255.614 137.107 255.551 136.822 255.495 136.536C255.44 136.571 254.435 133.978 252.84 133.914Z"
                fill="#263238"
            />
            <path
                d="M257.986 131.349C256.308 131.004 255.305 133.544 255.361 133.58C255.348 133.868 255.342 134.157 255.344 134.446C255.478 134.084 256.257 133.517 257.504 133.187C258.729 132.817 259.598 131.624 257.986 131.349Z"
                fill="#263238"
            />
            <path
                d="M253.095 130.56C251.436 130.277 251.9 132.525 253.154 133.027C254.365 133.562 255.152 134.099 255.318 134.446C255.296 134.157 255.282 133.867 255.275 133.578C255.215 133.606 254.657 130.891 253.095 130.56Z"
                fill="#263238"
            />
            <path
                d="M258.596 128.885C256.999 128.266 255.584 130.608 255.634 130.651C255.573 130.933 255.519 131.216 255.473 131.501C255.665 131.167 256.528 130.739 257.812 130.622C259.081 130.463 260.139 129.428 258.596 128.885Z"
                fill="#263238"
            />
            <path
                d="M253.908 127.289C252.319 126.734 252.399 129.034 253.552 129.737C254.657 130.467 255.343 131.128 255.449 131.497C255.476 131.209 255.51 130.922 255.551 130.635C255.487 130.654 255.391 127.88 253.908 127.289Z"
                fill="#263238"
            />
            <path
                d="M259.622 126.54C258.15 125.66 256.352 127.752 256.396 127.801C256.289 128.07 256.188 128.341 256.094 128.615C256.34 128.317 257.263 128.037 258.55 128.135C259.828 128.189 261.05 127.336 259.622 126.54Z"
                fill="#263238"
            />
            <path
                d="M255.272 124.176C253.798 123.361 253.48 125.661 254.499 126.549C255.465 127.458 256.03 128.226 256.072 128.609C256.147 128.329 256.229 128.05 256.318 127.773C256.249 127.783 256.631 125.012 255.272 124.176Z"
                fill="#263238"
            />
            <path
                d="M256.995 126.225C256.952 126.238 257.342 123.762 258.102 122.619C258.816 121.475 259.844 121.74 260.096 122.272C260.358 122.803 259.828 123.58 259.258 124.125C258.651 124.619 256.974 126.189 256.995 126.225Z"
                fill="#263238"
            />
            <path
                d="M257.035 126.309C257.031 126.311 257.027 126.312 257.023 126.314C256.985 126.325 256.943 126.311 256.919 126.28C256.918 126.278 256.916 126.275 256.915 126.272C256.901 126.249 256.891 126.232 256.905 126.199C256.898 125.736 257.371 123.549 258.024 122.567C258.376 122.004 258.864 121.695 259.364 121.725C259.724 121.745 260.044 121.944 260.18 122.232C260.535 122.95 259.613 123.914 259.322 124.192C258.731 124.674 257.205 126.104 257.081 126.261C257.072 126.282 257.055 126.3 257.035 126.309ZM258.87 122.007C258.654 122.107 258.41 122.302 258.181 122.668C257.582 123.57 257.22 125.292 257.117 125.952C257.256 125.813 257.478 125.603 257.827 125.278C258.277 124.859 258.873 124.317 259.199 124.053C259.745 123.53 260.249 122.794 260.012 122.313C259.904 122.085 259.646 121.928 259.353 121.911C259.234 121.904 259.063 121.918 258.87 122.007Z"
                fill="#263238"
            />
            <path
                d="M274.393 142.523H8.49609"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M209.611 2.58594H73.8678C65.2984 2.58594 58.3516 9.53278 58.3516 18.1022V83.6705C58.3516 92.2398 65.2984 99.1867 73.8678 99.1867H209.611C218.18 99.1867 225.127 92.2398 225.127 83.6705V18.1022C225.127 9.53278 218.18 2.58594 209.611 2.58594Z"
                fill="white"
            />
            <path
                d="M209.661 4.86328H73.6646C66.134 4.86328 60.0291 10.9726 60.0291 18.5031V42.2231H60.0273V60.3866H60.0291V83.1898C60.0291 90.7203 66.134 96.8297 73.6646 96.8297H209.661C217.196 96.8297 223.301 90.7203 223.301 83.1898V18.5031C223.301 10.9726 217.196 4.86328 209.661 4.86328Z"
                fill="#D6D6D6"
            />
            <path
                d="M159.636 40.4338H116.604V20.6792C116.604 20.3296 116.4 20.0119 116.082 19.8665L83.2785 4.86328H78.9811L114.816 21.2531V40.4338H60.0273V42.2215H82.0581C80.2975 60.062 88.7093 70.5129 96.1642 76.1579C102.599 81.0307 109.266 83.1972 112.001 83.9377L103.817 96.8262H105.935L120.591 73.7436V73.7581H146.737L142.529 96.8262H144.347L154.306 42.2215H159.206L202.825 96.8262H205.113L185.386 72.1313L210.851 53.3097C211.083 53.1387 211.213 52.8702 211.213 52.5909C211.213 52.5172 211.204 52.4427 211.186 52.3692L203.587 22.699H223.3V20.9114H186.292C185.955 20.9114 185.646 21.1008 185.494 21.4019L182.123 28.0661L169.699 16.677L174.243 4.86328H172.328L167.812 16.6037C167.681 16.9454 167.771 17.3351 168.042 17.5835L181.285 29.7231L169.74 52.5444L160.334 40.7699C160.165 40.5574 159.908 40.4338 159.636 40.4338ZM186.841 22.699H201.741L209.304 52.2297L184.27 70.7337L170.966 54.0797L186.841 22.699ZM152.489 42.2215L147.063 71.9704H121.716L140.605 42.2215H152.489ZM138.487 42.2215L113.008 82.3506C110.903 81.8137 103.869 79.7499 97.2435 74.7327C86.9361 66.9282 82.4358 55.9907 83.8519 42.2215H138.487Z"
                fill="white"
            />
            <path
                d="M141.24 4.86328V7.54029L158.138 14.2977V27.8124L141.615 20.6796V31.1911H125.473V15.4239L104.973 4.86328H141.24Z"
                fill="#C4C4C4"
            />
            <path d="M75.8164 79.9636V93.3711H86.9893V79.9636H75.8164Z" fill="#C4C4C4" />
            <path d="M75.8164 68.0732V77.7266H83.8609V68.0732H75.8164Z" fill="#C4C4C4" />
            <path
                d="M111.399 78.3167L132.828 45.1367H87.8966C87.8966 45.1367 85.5925 68.8697 111.399 78.3167Z"
                fill="#C4C4C4"
            />
            <path d="M75.8164 58.958V65.2148H81.0305V58.958H75.8164Z" fill="#C4C4C4" />
            <path
                d="M180.844 47.3378L189.335 59.4045L201.849 52.7008L200.508 28.5673L188.888 27.2266L184.866 36.6118L191.123 40.634L188.888 44.6563L182.184 41.0809L180.844 47.3378Z"
                fill="#C4C4C4"
            />
            <path d="M155.634 86.0039H179.777L185.283 96.8282H155.125L155.634 86.0039Z" fill="#C4C4C4" />
            <path d="M170.619 67.9844H156.481L155.777 83.0017H178.253L170.619 67.9844Z" fill="#C4C4C4" />
            <path d="M156.586 65.7331H169.473L164.892 56.7227H157.008L156.586 65.7331Z" fill="#C4C4C4" />
            <path d="M83.5117 5.72266L84.0411 5.96747" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path d="M85.1133 6.46094L114.556 20.0768" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path
                d="M115.09 20.3242L115.619 20.569V21.1523"
                stroke="#263238"
                strokeWidth="0.288482"
                strokeLinejoin="round"
            />
            <path d="M115.617 22.3008V40.0803" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path d="M115.618 40.6523V41.2356H115.035" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path d="M113.872 41.2383H84.1445" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path
                d="M83.5615 41.2383H82.9782C82.9782 41.2383 82.9325 41.4373 82.8672 41.809"
                stroke="#263238"
                strokeWidth="0.288482"
                strokeLinejoin="round"
            />
            <path
                d="M82.6924 42.9492C82.0854 47.6606 81.5052 61.1882 92.4728 71.9386C100.085 79.4004 109.312 82.2489 112.478 83.0499"
                stroke="#263238"
                strokeWidth="0.288482"
                strokeLinejoin="round"
            />
            <path
                d="M113.039 83.186C113.408 83.2714 113.608 83.3088 113.608 83.3088L113.92 82.8164"
                stroke="#263238"
                strokeWidth="0.288482"
                strokeLinejoin="round"
            />
            <path d="M114.559 81.8106L139.731 42.1641" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path
                d="M140.051 41.6643L140.363 41.1719H140.947"
                stroke="#263238"
                strokeWidth="0.288482"
                strokeLinejoin="round"
            />
            <path d="M142.117 41.1719H157.922" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path
                d="M158.508 41.1719H159.091L159.456 41.6272"
                stroke="#263238"
                strokeWidth="0.288482"
                strokeLinejoin="round"
            />
            <path d="M160.168 42.5156L186.909 75.9086" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path d="M187.266 76.3555L187.63 76.8107" stroke="#263238" strokeWidth="0.288482" strokeLinejoin="round" />
            <path
                d="M83.6297 43.1762L79.0349 46.5164L74.849 43.276L74.8437 43.2725C72.9483 41.9233 71.7109 39.7085 71.7109 37.2041C71.7109 33.0956 75.0427 29.7656 79.1511 29.7656C83.2596 29.7656 86.5896 33.0956 86.5896 37.2041C86.5896 39.6702 85.4762 41.8218 83.6297 43.1762Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M72.6211 37.1542C72.6211 38.7407 73.1866 40.1963 74.1256 41.3307C75.3263 42.7776 77.1379 43.6991 79.166 43.6991C81.0352 43.6991 82.7194 42.9172 83.9131 41.6623C85.0284 40.4878 85.7108 38.8995 85.7108 37.1542C85.7108 33.5397 82.7822 30.6094 79.166 30.6094C75.5515 30.6094 72.6211 33.5397 72.6211 37.1542Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M79.1675 43.6992C80.783 43.6992 82.2596 43.1143 83.4016 42.1456C83.1877 39.9331 81.3241 38.2031 79.0554 38.2031C76.8487 38.2031 75.0291 39.8413 74.7344 41.9669C75.9005 43.0412 77.4561 43.6992 79.1675 43.6992Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M81.9022 35.7137C82.1573 34.1413 81.0895 32.6598 79.5171 32.4047C77.9448 32.1495 76.4633 33.2173 76.2081 34.7897C75.9529 36.3621 77.0208 37.8436 78.5931 38.0987C80.1655 38.3539 81.647 37.2861 81.9022 35.7137Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M136.403 62.559L131.808 65.8992L127.622 62.6588L127.617 62.6553C125.722 61.3062 124.484 59.0914 124.484 56.5869C124.484 52.4784 127.816 49.1484 131.925 49.1484C136.033 49.1484 139.363 52.4784 139.363 56.5869C139.363 59.053 138.25 61.2047 136.403 62.559Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M125.395 56.5371C125.395 58.1235 125.96 59.5791 126.899 60.7136C128.1 62.1604 129.911 63.0819 131.939 63.0819C133.809 63.0819 135.493 62.3 136.687 61.0452C137.802 59.8706 138.484 58.2823 138.484 56.5371C138.484 52.9226 135.556 49.9922 131.939 49.9922C128.325 49.9922 125.395 52.9226 125.395 56.5371Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M131.937 63.082C133.553 63.082 135.029 62.4971 136.171 61.5284C135.957 59.3159 134.094 57.5859 131.825 57.5859C129.618 57.5859 127.799 59.2241 127.504 61.3497C128.67 62.4241 130.226 63.082 131.937 63.082Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M131.826 57.5186C133.419 57.5186 134.71 56.2273 134.71 54.6343C134.71 53.0413 133.419 51.75 131.826 51.75C130.233 51.75 128.941 53.0413 128.941 54.6343C128.941 56.2273 130.233 57.5186 131.826 57.5186Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M169.522 60.4386C169.103 60.8908 168.755 61.4287 168.758 61.6063C168.76 61.7839 170.916 64.753 171.216 65.1172C171.516 65.4814 172.336 66.1721 172.336 66.1721L178.245 73.3522C178.051 73.437 177.559 73.6533 177.459 73.7067C177.334 73.7734 177.61 73.9776 177.923 74.0079C178.235 74.0383 178.701 73.9061 178.701 73.9061L182.225 78.0133C182.225 78.0133 183.314 78.3752 184.15 78.0819C184.987 77.7885 186.439 76.8453 187.632 75.7193C188.826 74.5933 189.194 74.2545 189.194 74.2545C189.194 74.2545 189.433 74.0215 189.484 73.9081C189.534 73.7947 189.95 71.9427 189.754 71.5294C189.558 71.1161 189.37 71.019 189.37 71.019C189.37 71.019 186.658 67.6807 186.517 67.5093L186.503 67.4924C186.582 67.3391 186.818 66.8724 186.833 66.71C186.852 66.5147 186.666 66.2009 186.58 66.2715C186.504 66.3345 186.116 66.8537 186.034 66.9639L179.979 59.5219C179.979 59.5219 179.24 58.4054 178.764 57.827C178.288 57.2486 176.664 55.4943 176.338 55.4034C176.012 55.3126 175.741 55.4637 175.677 55.5166C175.612 55.5695 173.572 56.8893 172.873 57.3931C172.173 57.8969 169.94 59.9864 169.522 60.4386Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M185.109 67.1929L185.564 67.1779L182.2 63.0469L181.125 63.3565C181.125 63.3565 184.407 66.9079 185.109 67.1929Z"
                fill="white"
            />
            <path
                d="M180.557 62.7111L181.508 62.2515L177.895 58.2539C177.895 58.2539 178.18 59.7798 178.321 59.9512C178.462 60.1226 180.557 62.7111 180.557 62.7111Z"
                fill="white"
            />
            <path
                d="M170.884 62.2243C170.884 62.2243 171.187 61.544 171.834 60.9759C172.48 60.4079 175.466 57.8789 175.772 57.7706C176.078 57.6624 176.742 57.7268 176.742 57.7268C176.742 57.7268 176.382 56.7654 176.057 56.4578C175.732 56.1504 175.252 56.222 175.127 56.2887C175.002 56.3555 172.394 58.2509 171.718 58.9147C171.043 59.5785 169.888 60.7083 169.813 60.8783C169.737 61.0484 169.893 61.6747 170.055 61.8284C170.218 61.9821 170.884 62.2243 170.884 62.2243Z"
                fill="white"
            />
            <path
                d="M171.324 63.5898C171.324 63.5898 172.472 64.1546 172.656 64.2908C172.84 64.4269 175.139 67.1339 175.139 67.1339L174.449 67.9539L172.133 65.0088L171.324 63.5898Z"
                fill="white"
            />
            <path
                d="M175.129 68.6906L175.671 67.7773C175.671 67.7773 176.978 69.5403 177.267 70.0217C177.555 70.5031 178.691 72.4072 178.691 72.4072L178.581 72.9288L175.129 68.6906Z"
                fill="white"
            />
            <path
                d="M177.91 70.2786C177.91 70.2786 181.667 67.7258 183.02 65.9648L186.409 69.0338C186.409 69.0338 186.832 69.5479 186.842 69.6475C186.852 69.747 186.847 70.0028 186.847 70.0028C186.847 70.0028 185.99 71.9302 184.815 72.8609C183.641 73.7917 181.663 74.6642 181.443 74.7019C181.222 74.7397 180.861 74.606 180.861 74.606L180.319 74.2972L177.91 70.2786Z"
                fill="white"
            />
            <path
                d="M187.879 70.3398C187.879 70.3398 188.6 72.046 188.632 72.7389C188.663 73.4319 188.547 73.8149 188.547 73.8149C188.547 73.8149 189.101 73.1788 189.139 72.7882C189.177 72.3977 189.159 71.9819 189.029 71.6933C188.899 71.4048 187.879 70.3398 187.879 70.3398Z"
                fill="white"
            />
            <path
                d="M181.258 75.7891C181.258 75.7891 182.715 76.8176 183.173 76.9803C183.63 77.1429 184.419 77.1407 184.419 77.1407C184.419 77.1407 183.713 77.5058 183.475 77.5221C183.237 77.5385 182.322 77.2131 182.138 77.077C181.954 76.9408 181.282 75.9491 181.258 75.7891Z"
                fill="white"
            />
            <path
                d="M127.022 99.4287C127.022 99.4287 123.286 108.965 122.397 111.987C121.508 115.009 121.152 119.631 121.152 119.631L149.666 122.517C149.666 122.517 154.574 121.231 154.218 118.565C153.862 115.898 150.664 110.936 146.218 106.654C141.772 102.372 135.019 98.832 132.885 98.832C130.752 98.832 127.022 99.4287 127.022 99.4287Z"
                fill="#757575"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M227.006 109.633L228.683 117.272L222.348 118.576L227.006 109.633Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M246.153 117.864C244.924 114.382 243.081 114.177 243.081 114.177L237.755 100.453C237.755 100.453 231.815 101.272 229.357 103.321C226.899 105.369 221.164 118.478 221.164 118.478L225.67 146.95C225.67 146.95 244.31 143.058 244.924 142.648C245.539 142.238 246.153 138.347 246.358 135.889C246.563 133.431 247.382 121.346 246.153 117.864ZM223.466 117.363C223.466 117.363 228.311 106.929 229.429 105.439C230.547 103.948 232.41 103.109 232.41 103.109L236.262 102.229L240.142 114.662L223.466 117.363Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M223.281 118.202L228.685 117.27C228.685 117.27 230.827 113.171 231.48 112.612C232.132 112.053 233.063 111.494 234.647 111.867C236.231 112.239 239.585 114.103 239.398 115.314C239.212 116.525 238.933 116.898 237.163 117.177C235.392 117.457 230.734 117.457 230.734 117.457C230.734 117.457 229.523 119.413 229.244 119.786C228.964 120.158 224.399 121.649 224.399 121.649C224.399 121.649 223.84 120.158 223.281 118.202Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M204.957 159.859C204.957 159.859 203.85 160.85 203.325 161.258C202.801 161.666 201.927 162.423 201.053 162.714C200.178 163.006 199.712 163.181 199.77 163.647C199.829 164.113 199.829 164.579 200.12 164.637C200.412 164.696 210.9 164.637 210.9 164.637C210.9 164.637 211.192 164.171 211.133 163.122C211.075 162.073 210.726 161.258 210.726 161.258C210.726 161.258 208.045 160.5 206.88 159.859C205.714 159.218 204.957 159.859 204.957 159.859Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M211.073 164.113H199.824C199.863 164.386 199.929 164.6 200.119 164.638C200.411 164.696 210.9 164.638 210.9 164.638C210.9 164.638 211.002 164.468 211.073 164.113Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M201.52 120.117C201.52 120.117 200.763 125.012 201.52 130.082C202.278 135.151 203.094 138.764 203.094 138.764C203.094 138.764 204.259 143.834 204.376 145.465C204.492 147.097 205.599 155.721 205.541 155.896C205.483 156.071 205.366 156.479 205.366 156.77C205.366 157.061 204.609 157.469 204.725 157.819C204.842 158.168 204.958 159.858 204.958 159.858C204.958 159.858 206.299 159.625 206.881 159.858C207.464 160.091 210.086 161.024 210.086 161.024L210.727 161.257C210.727 161.257 211.426 160.732 211.426 159.917C211.426 159.101 210.378 158.168 210.378 158.168C210.378 158.168 211.077 157.877 211.135 157.586C211.193 157.294 210.844 156.245 210.844 156.071C210.844 155.896 210.727 154.148 210.727 153.798C210.727 153.448 210.785 149.02 210.785 148.495C210.785 147.971 210.261 139.929 210.261 139.929L209.678 134.102C209.678 134.102 211.077 140.687 211.659 142.785C212.242 144.883 213.932 153.682 213.99 153.973C214.049 154.264 214.282 156.537 214.223 156.712C214.165 156.886 213.524 157.294 213.582 157.527C213.641 157.761 214.049 160.674 214.049 160.674L218.244 161.024C218.244 161.024 218.71 160.15 218.943 159.509C219.177 158.868 218.769 158.285 218.769 158.052C218.769 157.819 219.118 157.877 219.002 156.945C218.885 156.012 218.769 155.255 218.769 155.255C218.769 155.255 218.477 154.789 218.419 153.157C218.361 151.525 219.293 147.039 218.652 144.475C218.011 141.911 217.254 139.755 217.195 136.958C217.137 134.161 217.137 128.916 216.904 127.518C216.671 126.119 216.297 121.745 216.297 121.745L216.146 121.108L201.52 120.117Z"
                fill="#8C8C8C"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M206.531 128.156L208.746 129.205L209.503 133.459"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M214.513 159.799C214.513 159.799 214.105 161.255 213.697 161.955C213.289 162.654 212.648 163.062 212.474 163.47C212.299 163.878 212.357 164.635 212.357 164.635H218.592C218.592 164.635 219.058 164.052 219.058 162.654C219.058 161.255 218.534 160.556 218.068 159.74C217.601 158.925 216.028 158.342 214.513 159.799Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M218.922 163.843L218.825 163.82H212.382C212.324 164.207 212.357 164.636 212.357 164.636H218.592C218.592 164.636 218.784 164.39 218.922 163.843Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M205.523 95.0672C205.523 95.0672 204.371 96.2524 203.458 96.7549C202.544 97.2575 201.036 97.7143 200.762 98.2626C200.488 98.8108 200.168 102.603 200.579 104.567C200.99 106.532 201.493 107.902 201.493 107.902L201.813 115.167L201.31 120.74C201.31 120.74 206.838 121.471 210.356 121.883C213.874 122.294 216.295 121.745 216.295 121.745C216.295 121.745 216.478 118.41 216.524 116.674C216.57 114.938 216.661 106.76 216.661 106.76L219.448 111.42C219.448 111.42 221.388 112.675 224.529 110.646C225.415 110.074 222.009 106.422 221.781 105.28C221.553 104.138 220.087 101.689 220.087 101.689C220.087 101.689 218.9 98.1255 217.986 97.2118C217.072 96.2981 215.839 96.0696 214.514 95.8868C213.189 95.7041 211.004 94.8008 211.004 94.8008L205.523 95.0672Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M221.52 106.59C221.52 106.59 220.08 106.786 219.688 109.273"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M218.773 107.571C218.773 107.571 219.755 106.59 220.867 106.59"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M201.643 86.0102C201.643 86.0102 201.757 89.9685 201.91 90.6156C202.062 91.2626 203.128 92.5947 203.584 93.2037C204.041 93.8127 204.993 93.9649 205.107 93.9649C205.221 93.9649 205.525 94.4217 205.525 95.0687C205.525 95.7158 205.259 95.8299 205.297 97.695C205.335 99.56 205.602 101.159 205.602 101.159C205.602 101.159 206.705 100.435 208.608 98.3801C210.512 96.3247 211.006 94.8023 211.006 94.8023C211.006 94.8023 210.169 94.0411 209.903 93.1656C209.636 92.2903 209.674 90.0827 209.674 90.0827C209.674 90.0827 211.044 89.017 211.12 88.408C211.197 87.799 210.626 86.6572 210.626 86.6572C210.626 86.6572 209.979 84.3735 209.255 83.2317C208.532 82.0898 208.418 81.5189 206.02 82.166C203.622 82.813 202.785 82.9652 202.024 83.5362C201.263 84.1071 201.148 84.7922 201.148 84.7922L201.643 86.0102Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M205.105 93.9625C205.105 93.9625 205.829 93.8864 206.247 93.7722C206.666 93.658 207.237 93.4297 207.237 93.4297L205.524 95.0663L205.105 93.9625Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M203.031 90.3398C203.031 90.3398 203.298 90.7585 203.678 90.6063C204.059 90.454 204.274 90.3478 204.274 90.3478"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M204.078 91.4515C204.078 91.4515 205.448 91.6418 206.248 90.5"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M204.574 87.3397C204.574 87.3397 205.792 86.9972 206.439 87.3397"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M202.977 87.4936C202.977 87.4936 202.33 87.0749 201.949 87.5697"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M202.607 88.4114C202.637 88.6629 202.554 88.8796 202.42 88.8956C202.286 88.9116 202.153 88.7209 202.123 88.4695C202.093 88.2181 202.177 88.0014 202.311 87.9853C202.444 87.9693 202.577 88.1601 202.607 88.4114Z"
                fill="#263238"
            />
            <path
                d="M205.326 88.306C205.356 88.5574 205.272 88.7741 205.139 88.7902C205.005 88.8062 204.872 88.6154 204.842 88.364C204.812 88.1126 204.896 87.8959 205.029 87.8798C205.163 87.8638 205.296 88.0546 205.326 88.306Z"
                fill="#263238"
            />
            <path
                d="M207.162 83.6492C207.162 83.6492 205.868 84.6387 205.449 84.7149C205.031 84.791 203.546 84.2962 203.013 84.2581C202.481 84.2201 201.491 85.0194 201.491 85.0194L201.643 86.009C201.643 86.009 200.197 85.6664 199.892 85.0955C199.588 84.5246 200.616 83.7633 200.578 83.573C200.539 83.3827 200.007 82.6596 200.387 82.4312C200.768 82.2028 202.443 81.67 202.443 81.67C202.443 81.67 203.318 79.843 203.927 79.805C204.536 79.7669 205.678 79.9953 205.678 79.9953C205.678 79.9953 206.287 79.4244 207.01 79.5385C207.733 79.6527 208.799 80.9849 208.799 80.9849C208.799 80.9849 210.397 80.8326 210.702 81.5177C211.006 82.2028 211.311 83.1163 211.082 83.8395C210.854 84.5626 210.626 86.0851 210.626 86.0851V86.656C210.626 86.656 209.979 86.7702 209.674 87.0366C209.37 87.303 209.408 87.5314 209.179 87.7217C208.951 87.912 208.837 87.912 208.685 87.8359C208.532 87.7597 208.456 87.5314 208.38 87.0746C208.304 86.6179 208.228 86.5038 207.923 86.3896C207.619 86.2754 207.2 86.047 206.896 85.7045C206.591 85.3619 206.211 85.0574 206.439 84.7529C206.667 84.4484 207.162 83.6492 207.162 83.6492Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M214.97 104.387L216.661 106.762L213.828 105.803"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M167.7 153.658C123.948 152.269 88.4805 155.61 88.4805 161.12C88.4805 163.445 94.7991 165.786 105.392 167.818C95.8168 168.012 88.8369 168.613 88.8369 169.324C88.8369 170.192 99.2373 170.896 112.067 170.896C116.709 170.896 121.03 170.804 124.659 170.645C137.052 172.05 151.83 173.108 167.7 173.612C211.452 175.001 246.92 171.66 246.92 166.15C246.92 160.64 211.452 155.048 167.7 153.658Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.4842 146.532C90.4842 146.532 91.4481 148.619 92.1356 149.331C92.823 150.043 105.252 153.118 105.252 153.118L145.522 161.932L150.402 161.409L167.456 161.955C167.456 161.955 170.859 153.631 167.143 145.43C163.427 137.229 144.847 134.026 139.594 135.691C134.34 137.357 122.039 142.739 113.197 139.792C104.355 136.845 97.3078 131.078 94.3606 131.847C91.4134 132.616 90.0039 137.357 90.0039 139.407C90.0039 141.458 90.4842 146.532 90.4842 146.532Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M177.059 157.935C176.708 149.471 171.046 142.595 164.412 142.578H157.221L157.346 145.61C154.537 148.398 152.828 152.851 153.037 157.874C153.245 162.896 155.323 167.359 158.365 170.162L158.492 173.231H165.684C172.317 173.248 177.41 166.4 177.059 157.935Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M159.547 173.174C166.124 172.445 170.699 165.019 169.765 156.586C168.832 148.153 162.743 141.906 156.166 142.635C149.589 143.363 145.015 150.789 145.948 159.223C146.882 167.656 152.971 173.902 159.547 173.174Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M167.149 163.121L167.149 163.12C167.267 162.741 167.37 162.352 167.457 161.955L167.458 161.954C167.545 161.556 167.618 161.15 167.674 160.736C167.796 159.833 167.844 158.895 167.804 157.93C167.719 155.875 167.253 153.934 166.503 152.215L166.482 152.168C166.314 151.788 166.132 151.419 165.937 151.061C165.925 151.039 165.914 151.017 165.901 150.995C165.706 150.641 165.498 150.3 165.278 149.972C165.266 149.954 165.255 149.936 165.243 149.919C163.3 147.054 160.445 145.219 157.33 145.211C154.662 145.204 152.298 146.54 150.602 148.716C150.49 148.86 150.38 149.008 150.274 149.159C150.168 149.31 150.065 149.464 149.966 149.622L149.963 149.626C149.865 149.781 149.77 149.94 149.678 150.101L149.671 150.114C149.581 150.273 149.494 150.434 149.41 150.599L149.398 150.622C149.317 150.783 149.238 150.945 149.163 151.111C149.157 151.124 149.151 151.137 149.145 151.15C149.073 151.311 149.004 151.473 148.937 151.638C148.93 151.658 148.922 151.676 148.914 151.696C148.85 151.856 148.79 152.018 148.732 152.182C148.723 152.207 148.714 152.232 148.705 152.257C148.65 152.415 148.598 152.576 148.549 152.738C148.539 152.77 148.528 152.802 148.518 152.834C148.472 152.99 148.429 153.147 148.387 153.306C148.377 153.346 148.365 153.386 148.355 153.426C148.317 153.578 148.282 153.732 148.248 153.887C148.238 153.935 148.226 153.983 148.216 154.031C148.185 154.179 148.158 154.329 148.131 154.48C148.121 154.536 148.11 154.591 148.101 154.648C148.077 154.793 148.057 154.94 148.037 155.087C148.029 155.15 148.019 155.212 148.011 155.275C147.993 155.418 147.98 155.563 147.966 155.707C147.96 155.776 147.952 155.844 147.946 155.913C147.935 156.056 147.927 156.2 147.92 156.345C147.916 156.417 147.91 156.488 147.907 156.561C147.901 156.713 147.9 156.866 147.898 157.02C147.897 157.085 147.894 157.15 147.895 157.216C147.895 157.436 147.899 157.657 147.908 157.879C147.92 158.149 147.94 158.415 147.964 158.681C147.969 158.745 147.976 158.808 147.983 158.872C148.006 159.1 148.034 159.327 148.066 159.551C148.071 159.586 148.076 159.621 148.081 159.655C148.165 160.213 148.278 160.758 148.416 161.29C149.102 163.934 150.427 166.232 152.142 167.883C152.163 167.904 152.184 167.925 152.206 167.945C152.416 168.144 152.631 168.333 152.853 168.513C152.868 168.525 152.883 168.536 152.898 168.548C154.507 169.839 156.391 170.593 158.383 170.598C160.389 170.603 162.222 169.848 163.731 168.55C165.263 167.23 166.457 165.347 167.149 163.121Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M166.668 158.315C166.607 156.838 166.312 155.432 165.831 154.152L161.879 156.628C162.05 157.153 162.158 157.717 162.183 158.306C162.186 158.391 162.183 158.473 162.183 158.557L166.672 159.287C166.681 158.967 166.681 158.643 166.668 158.315Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M159.664 153.775C160.075 154 160.451 154.309 160.784 154.683L163.566 150.401C162.6 149.344 161.458 148.545 160.214 148.09L159.664 153.775Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M161.618 161.094C161.417 161.498 161.167 161.857 160.879 162.162L163.164 167.276C164.259 166.359 165.154 165.105 165.767 163.624L161.618 161.094Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M154.895 155.643L150.865 152.84C150.274 154.217 149.931 155.796 149.902 157.486L154.407 157.615C154.455 156.897 154.626 156.228 154.895 155.643Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M156.264 153.94C156.593 153.709 156.955 153.541 157.34 153.446L156.681 147.762C155.255 148.014 153.965 148.728 152.902 149.783L156.264 153.94Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.919 163.215C158.779 163.235 158.636 163.246 158.491 163.246C158.08 163.245 157.681 163.162 157.303 163.012L155.094 167.91C156.209 168.568 157.441 168.939 158.725 168.942C159.076 168.942 159.42 168.913 159.757 168.86L158.919 163.215Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M154.862 160.41L150.406 161.407C150.867 163.036 151.62 164.498 152.58 165.692L155.44 161.472C155.214 161.151 155.021 160.793 154.862 160.41Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M109.616 149.376C109.451 142.283 106.795 136.522 103.682 136.508H96.5078L97.1044 162.192H104.279C107.391 162.207 109.781 156.468 109.616 149.376Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M102.44 149.376C102.604 156.469 100.215 162.207 97.1022 162.192C93.9897 162.178 91.3329 156.417 91.1682 149.324C91.0034 142.232 93.3931 136.494 96.5056 136.508C99.6181 136.522 102.275 142.283 102.44 149.376Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M101.167 153.722L101.167 153.721C101.222 153.404 101.271 153.078 101.312 152.745L101.312 152.744C101.353 152.411 101.387 152.071 101.413 151.724C101.471 150.967 101.493 150.181 101.475 149.373C101.435 147.65 101.216 146.024 100.864 144.584L100.854 144.544C100.775 144.226 100.69 143.916 100.599 143.617C100.593 143.599 100.587 143.58 100.582 143.561C100.49 143.265 100.392 142.979 100.289 142.704C100.284 142.689 100.278 142.674 100.273 142.66C99.3614 140.259 98.0216 138.722 96.56 138.715C95.3084 138.709 94.199 139.829 93.4032 141.652C93.3505 141.773 93.2992 141.897 93.2494 142.023C93.1997 142.15 93.1513 142.279 93.1046 142.411L93.1035 142.414C93.0574 142.544 93.0128 142.677 92.9696 142.813L92.9661 142.823C92.9239 142.956 92.8833 143.092 92.8439 143.229L92.8381 143.249C92.8 143.383 92.7634 143.52 92.7281 143.659C92.7253 143.67 92.7224 143.68 92.7196 143.692C92.6857 143.826 92.6533 143.962 92.6221 144.101C92.6185 144.117 92.6147 144.132 92.6111 144.149C92.5813 144.283 92.553 144.419 92.5257 144.556C92.5215 144.577 92.5172 144.598 92.5131 144.619C92.4873 144.751 92.4631 144.886 92.4398 145.022C92.4351 145.049 92.4301 145.075 92.4255 145.103C92.4038 145.233 92.3835 145.365 92.3641 145.498C92.3591 145.532 92.3538 145.565 92.3489 145.599C92.331 145.726 92.3145 145.855 92.2987 145.985C92.2938 146.025 92.2883 146.065 92.2836 146.105C92.2691 146.23 92.2563 146.355 92.2439 146.481C92.2393 146.528 92.234 146.575 92.2296 146.622C92.2185 146.744 92.2091 146.867 92.1998 146.99C92.1958 147.043 92.1911 147.095 92.1874 147.148C92.1792 147.268 92.1729 147.389 92.1666 147.51C92.1635 147.568 92.1597 147.625 92.157 147.683C92.1517 147.802 92.1483 147.923 92.1447 148.044C92.1428 148.104 92.1401 148.164 92.1388 148.225C92.136 148.352 92.1353 148.481 92.1344 148.61C92.1341 148.665 92.1328 148.719 92.1328 148.774C92.133 148.958 92.1351 149.144 92.1394 149.33C92.1446 149.556 92.1539 149.779 92.1652 150.002C92.168 150.055 92.1712 150.108 92.1743 150.162C92.1852 150.353 92.1982 150.543 92.2135 150.731C92.2158 150.76 92.2179 150.789 92.2203 150.818C92.2599 151.285 92.3128 151.742 92.3775 152.188C92.6995 154.404 93.3209 156.329 94.1259 157.713C94.1358 157.73 94.1457 157.747 94.1558 157.764C94.2542 157.931 94.3554 158.09 94.4591 158.24C94.4662 158.25 94.4733 158.26 94.4804 158.27C95.2353 159.351 96.1196 159.983 97.0541 159.988C97.9951 159.992 98.8556 159.359 99.5633 158.271C100.282 157.165 100.843 155.587 101.167 153.722Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M246.317 153.029C245.965 144.564 240.303 137.689 233.67 137.672H226.478C219.845 137.655 214.752 144.503 215.103 152.967C215.454 161.432 221.116 168.307 227.75 168.324H234.941C241.575 168.341 246.668 161.493 246.317 153.029Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M249.172 147.603C249.172 147.603 248.904 142.247 248.234 140.372C247.565 138.497 245.556 135.685 245.556 135.685C245.556 135.685 243.547 130.998 240.2 128.052C236.852 125.106 231.361 122.16 230.022 121.49C228.683 120.821 226.942 120.419 224.398 118.678C221.854 116.937 206.052 105.956 201.097 103.01C196.142 100.064 185.429 98.5912 183.287 98.1895C181.144 97.7878 156.504 96.0469 147.934 96.0469C139.364 96.0469 121.687 96.4486 111.912 100.198C111.912 100.198 108.698 101.136 108.296 102.073C107.894 103.01 107.627 103.68 107.627 103.68L97.9848 117.741C97.9848 117.741 94.5031 117.473 93.4318 120.419C92.3605 123.365 92.7622 127.382 92.7622 127.382C92.7622 127.382 90.2179 133.676 90.084 138.363C89.95 143.05 90.4857 146.532 90.4857 146.532C90.4857 146.532 89.8161 137.961 91.8248 135.283C93.8335 132.605 97.9848 134.614 99.5917 139.434C101.199 144.255 103.073 153.227 103.073 153.227L145.524 161.932C145.524 161.932 143.381 150.683 146.193 144.255C149.005 137.827 162.129 138.229 164.539 149.88C166.95 161.53 166.146 163.673 166.146 163.673C166.146 163.673 175.118 165.547 202.436 165.146C229.754 164.744 244.753 161.53 248.77 160.459C248.77 160.459 249.707 155.504 249.975 152.558C250.243 149.612 249.172 147.603 249.172 147.603ZM151.817 120.687C151.55 121.356 151.014 121.758 151.014 121.758C149.943 122.829 146.997 121.758 146.997 121.758C146.997 121.758 134.255 119.733 122.862 117.956C123.549 110.64 126.941 103.585 129.02 99.8554C131.182 100.032 135.852 100.619 141.238 104.483C147.398 108.902 152.085 120.017 151.817 120.687Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.15"
                d="M249.975 152.557C250.243 149.61 249.172 147.602 249.172 147.602C249.172 147.602 249.086 145.888 248.89 144.06C232.134 149.004 202.153 149.337 193.792 148.6C184.187 147.752 167.145 145.429 166.389 142.667C165.634 139.906 159.044 133.627 154.524 131.932C150.65 130.479 105.683 124.253 92.9151 122.504C92.5235 124.963 92.7622 127.381 92.7622 127.381C92.7622 127.381 90.2179 133.675 90.084 138.362C89.9501 143.049 90.4857 146.531 90.4857 146.531C90.4857 146.531 89.8161 137.96 91.8248 135.282C93.8335 132.604 97.9848 134.612 99.5917 139.433C101.199 144.254 103.073 153.226 103.073 153.226L145.524 161.93C145.524 161.93 143.381 150.682 146.193 144.254C149.005 137.826 162.129 138.228 164.539 149.878C166.95 161.529 166.146 163.671 166.146 163.671C166.146 163.671 175.118 165.546 202.436 165.144C229.754 164.743 244.752 161.529 248.77 160.457C248.77 160.457 249.707 155.503 249.975 152.557Z"
                fill="black"
            />
            <path
                d="M143.884 118.768C144.456 115.815 146.361 110.289 146.361 110.289C146.361 110.289 149.534 114.783 150.976 117.928C152.418 121.075 150.976 122.254 149.665 122.516C148.354 122.779 143.242 121.075 143.242 121.075L143.884 118.768Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M125.353 99.8438C122.735 99.9942 119.053 100.382 116.199 101.002C113.119 101.672 112.048 101.806 111.512 102.341C110.976 102.877 105.754 109.439 103.879 114.126C103.879 114.126 104.147 115.331 105.352 115.331C105.79 115.331 111.415 116.18 118.395 117.262C119.563 113.106 121.912 105.785 125.353 99.8438Z"
                fill="#757575"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M122.981 124.274L119.172 123.586C119.172 123.586 118.24 123.882 118.522 124.815C118.804 125.748 119.309 125.646 119.309 125.646L122.48 126.156C122.48 126.156 123.235 126.238 123.397 125.485C123.558 124.733 123.772 124.636 122.981 124.274Z"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M103.723 120.953L100.814 120.395C100.814 120.395 100.103 120.635 100.318 121.393C100.533 122.15 100.919 122.068 100.919 122.068L103.34 122.482C103.34 122.482 103.916 122.548 104.04 121.937C104.163 121.326 104.326 121.247 103.723 120.953Z"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M127.024 99.4297C127.024 99.4297 121.593 109.529 120.641 117.913"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M119.399 119.625C119.399 119.625 116.922 123.817 116.827 125.246C116.732 126.675 117.017 143.824 117.494 146.968"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M145.601 125.629C145.601 125.629 143.505 132.584 143.409 137.824C143.314 143.064 143.219 152.877 143.219 152.877"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M103.585 116.008C103.585 116.008 99.107 120.105 98.7259 121.438C98.3448 122.772 98.8212 134.205 98.8212 134.205"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M104.441 147.16C104.441 147.16 105.108 149.066 106.537 149.542C107.966 150.018 142.646 156.687 142.646 156.687"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M204.906 153.207C204.906 153.207 231.463 153.573 241.331 150.527C241.331 150.527 240.356 157.106 238.529 158.446C236.701 159.786 223.421 161.154 216.966 161.369C209.657 161.613 205.515 160.882 205.515 160.882L204.906 153.207Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M200.156 136.64L202.836 142.122C202.836 142.122 217.82 142.488 219.526 142.609C221.231 142.731 223.059 143.584 225.008 142.609C226.957 141.635 235.362 140.538 236.337 140.538C237.311 140.538 238.53 141.391 238.53 141.391C238.53 141.391 236.337 135.909 235.484 135.422C234.631 134.935 233.779 135.057 233.413 135.057C233.048 135.057 215.262 133.716 200.156 136.64Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M171.915 125.697C171.915 125.697 165.544 124.717 163.094 125.574C160.643 126.432 161.869 129.74 166.034 132.803C170.2 135.866 173.63 138.806 177.918 139.296C182.206 139.786 189.557 141.379 189.925 140.032C190.293 138.684 188.945 133.783 184.044 130.23C179.143 126.677 171.915 125.697 171.915 125.697Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M223.125 118.713L221.902 119.083C221.902 119.083 219.629 119.152 215.992 119.252C212.875 119.343 208.759 119.457 204.209 119.576C197.929 119.745 190.828 119.918 184.416 120.055C174.613 120.261 166.408 120.365 165.176 120.183C163.058 119.873 160.69 119.106 158.49 117.18C157.253 116.103 156.067 114.656 155.008 112.712C152.064 107.318 144.594 100.705 144.594 100.705C156.354 99.3545 184.412 99.8473 187.597 99.9705C188.391 99.9979 189.409 100.121 190.54 100.327C193.94 100.929 198.376 102.266 200.95 104.014C201.406 104.324 202.141 104.813 203.063 105.429C205.217 106.866 208.412 108.984 211.62 111.11C213.555 112.388 215.494 113.671 217.215 114.812C220.592 117.039 223.125 118.713 223.125 118.713Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M200.952 104.012C201.409 104.322 202.143 104.81 203.065 105.426L184.418 120.053C174.615 120.258 166.41 120.363 165.178 120.181C163.06 119.87 160.692 119.104 158.492 117.178L190.543 100.324C193.943 100.927 198.378 102.264 200.952 104.012Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M217.217 114.807L215.994 119.247C212.877 119.338 208.761 119.452 204.211 119.571L211.622 111.105C213.557 112.383 215.497 113.666 217.217 114.807Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M196.719 132.973C197.465 133.728 198.186 134.528 198.87 135.375"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M178.652 122.145C178.652 122.145 187.925 124.872 195.429 131.736"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M238.047 135.16C238.973 136.906 239.713 138.853 240.157 141.012"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M223.863 122.633C223.863 122.633 232.078 125.815 237.004 133.387"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M186.005 155.592C186.005 157.013 184.633 158.165 182.942 158.165C181.25 158.165 179.879 157.013 179.879 155.592C179.879 154.171 181.25 153.02 182.942 153.02C184.633 153.02 186.005 154.171 186.005 155.592Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M249.437 151.411C249.178 152.636 248.35 153.498 247.589 153.337C246.828 153.176 246.421 152.053 246.68 150.828C246.938 149.604 247.765 148.741 248.527 148.902C249.288 149.063 249.695 150.186 249.437 151.411Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M145.064 121.15C145.064 121.15 142.927 117.55 141.577 117.325C140.227 117.1 134.49 116.875 133.253 117.663C132.016 118.45 132.353 121.038 132.803 121.712C133.253 122.387 135.053 122.725 136.628 122.612C138.202 122.5 143.489 122.95 143.489 122.95C143.489 122.95 146.639 125.2 147.764 124.975C148.889 124.75 150.351 122.275 149.339 120.925C148.326 119.575 146.752 119.913 145.064 121.15Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M145.062 121.148L148.775 121.936"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M111.912 100.198C111.912 100.198 108.698 101.136 108.296 102.073C107.894 103.01 107.626 103.68 107.626 103.68L97.9848 117.741C97.9848 117.741 94.5031 117.473 93.4318 120.419C92.3605 123.365 92.7622 127.382 92.7622 127.382C92.7622 127.382 90.2179 133.676 90.084 138.363C89.95 143.05 90.4857 146.532 90.4857 146.532C90.4857 146.532 89.8161 137.961 91.8248 135.283C93.8335 132.605 97.9848 134.614 99.5917 139.434C101.199 144.255 103.073 153.227 103.073 153.227L145.524 161.932C145.524 161.932 143.381 150.683 146.193 144.255C149.005 137.827 162.129 138.229 164.539 149.88C166.95 161.53 166.146 163.673 166.146 163.673C166.146 163.673 175.118 165.547 202.436 165.146C229.754 164.744 244.752 161.53 248.77 160.459C248.77 160.459 249.707 155.504 249.975 152.558C250.243 149.612 249.172 147.603 249.172 147.603C249.172 147.603 248.904 142.247 248.234 140.372C247.565 138.497 245.556 135.685 245.556 135.685C245.556 135.685 243.547 130.998 240.199 128.052C236.852 125.106 231.361 122.16 230.022 121.49C228.683 120.821 226.942 120.419 224.398 118.678C221.853 116.937 206.052 105.956 201.097 103.01C196.142 100.064 185.429 98.5912 183.287 98.1895C181.144 97.7878 156.504 96.0469 147.934 96.0469C139.364 96.0469 121.687 96.4486 111.912 100.198Z"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M235.38 124.594C235.38 124.594 232.685 125.574 233.42 126.554C234.155 127.534 238.198 130.107 240.036 133.292C241.874 136.478 242.241 138.071 243.099 138.071C243.957 138.071 245.811 136.483 245.558 135.684C245.304 134.885 243.957 127.657 235.38 124.594Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M100.57 149.142C100.542 147.825 100.407 146.57 100.187 145.43L98.375 147.638C98.4533 148.106 98.5031 148.608 98.5142 149.134C98.5158 149.209 98.5143 149.283 98.5144 149.357L100.572 150.009C100.576 149.723 100.576 149.434 100.57 149.142Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M97.3594 145.093C97.5475 145.293 97.7202 145.569 97.8725 145.902L99.1481 142.085C98.705 141.142 98.1815 140.43 97.6115 140.023L97.3594 145.093Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M98.2566 151.621C98.1644 151.981 98.0499 152.302 97.918 152.574L98.9654 157.134C99.4673 156.316 99.8775 155.198 100.158 153.877L98.2566 151.621Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M95.1752 146.758L93.3281 144.258C93.0571 145.486 92.9 146.894 92.8867 148.401L94.9517 148.516C94.9737 147.875 95.0518 147.279 95.1752 146.758Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M95.8026 145.239C95.9534 145.034 96.1193 144.884 96.296 144.799L95.9938 139.73C95.3403 139.956 94.7489 140.592 94.2617 141.533L95.8026 145.239Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M97.0189 153.51C96.9547 153.527 96.8894 153.537 96.8229 153.537C96.6345 153.536 96.4515 153.462 96.2782 153.328L95.2656 157.696C95.7768 158.283 96.3414 158.614 96.9303 158.616C97.0911 158.617 97.2486 158.59 97.4032 158.543L97.0189 153.51Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M95.1596 151.012L93.1172 151.9C93.3283 153.353 93.6738 154.657 94.1137 155.721L95.4246 151.959C95.3211 151.672 95.2326 151.353 95.1596 151.012Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.7872 111.352C90.7872 111.352 113.395 112.616 115.383 113.444C117.371 114.273 117.868 116.261 117.868 116.261L89.5391 115.267L90.7872 111.352Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M107.316 100.223C107.316 100.223 94.4273 109.596 89.5404 115.268L84.5703 114.274L98.3562 101.048L107.316 100.223Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M120.638 117.913C120.638 117.913 123.074 106.031 127.021 99.4298C127.021 99.4298 113.184 97.5676 98.1082 99.887C97.2321 100.022 83.5748 111.456 83.5748 111.456C83.5748 111.456 75.6027 118.263 75.457 119.574C75.457 119.574 80.4018 136.794 98.4037 148.554L117.953 151.714C117.953 151.714 116.644 130.482 116.835 125.902C116.951 123.129 120.638 117.913 120.638 117.913ZM87.8821 113.61C85.8941 112.947 87.8821 110.959 87.8821 110.959L99.68 101.544C107.798 100.218 122.507 101.682 122.507 101.682C121.513 103.504 117.868 116.261 117.868 116.261C117.868 116.261 89.8701 114.273 87.8821 113.61Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M81.5873 118.299L79.0875 118.082C79.0875 118.082 78.1094 118.191 78.1094 119.06C78.1094 119.93 78.8701 120.038 78.8701 120.038L83.7147 120.477C83.7147 120.477 83.6002 119.011 84.361 118.576L81.5873 118.299Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78.2305 120.328C78.2305 120.328 79.0268 121.363 79.8232 121.363C80.6196 121.363 83.6459 121.682 83.6459 121.682"
                fill="#145DA0"
            />
            <path
                d="M78.2305 120.328C78.2305 120.328 79.0268 121.363 79.8232 121.363C80.6196 121.363 83.6459 121.682 83.6459 121.682"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M236.262 102.226L237.224 102.152L241.295 114.513L240.142 114.659L236.262 102.226Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M229.637 101.617C229.637 101.617 231.077 100.832 231.404 100.832C231.731 100.832 232.909 102.403 232.909 102.403C232.909 102.403 231.273 103.319 231.077 103.384C230.88 103.45 229.768 102.926 229.768 102.926C229.768 102.926 228.655 103.777 228.132 104.758C227.608 105.74 225.449 109.339 225.449 109.339C225.449 109.339 224.271 111.04 223.028 110.32C221.785 109.601 221.327 107.899 221.85 107.179C222.373 106.46 229.637 101.617 229.637 101.617Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M228.523 103.448C228.523 103.448 228.916 103.906 229.309 103.972C229.701 104.037 230.814 104.037 230.814 104.037C230.814 104.037 232.057 103.906 231.075 103.383C230.094 102.859 229.309 102.598 229.309 102.598"
                fill="white"
            />
            <path
                d="M228.523 103.448C228.523 103.448 228.916 103.906 229.309 103.972C229.701 104.037 230.814 104.037 230.814 104.037C230.814 104.037 232.057 103.906 231.075 103.383C230.094 102.859 229.309 102.598 229.309 102.598"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M140.658 95.8605L135.403 99.6806L130.616 95.9746L130.61 95.9706C128.443 94.4277 127.027 91.8947 127.027 89.0305C127.027 84.3318 130.838 80.5234 135.536 80.5234C140.235 80.5234 144.043 84.3318 144.043 89.0305C144.043 91.8508 142.77 94.3116 140.658 95.8605Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M128.07 88.9733C128.07 90.7877 128.717 92.4524 129.791 93.7498C131.164 95.4045 133.236 96.4584 135.555 96.4584C137.693 96.4584 139.619 95.5642 140.985 94.1291C142.26 92.7857 143.04 90.9694 143.04 88.9733C143.04 84.8396 139.691 81.4883 135.555 81.4883C131.422 81.4883 128.07 84.8396 128.07 88.9733Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M135.554 96.4614C137.402 96.4614 139.091 95.7925 140.397 94.6847C140.152 92.1543 138.021 90.1758 135.426 90.1758C132.902 90.1758 130.821 92.0493 130.484 94.4802C131.818 95.7089 133.597 96.4614 135.554 96.4614Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
            <path
                d="M138.637 87.5576C139.057 85.785 137.961 84.0074 136.188 83.5873C134.415 83.1672 132.638 84.2637 132.218 86.0364C131.798 87.8091 132.894 89.5866 134.667 90.0067C136.439 90.4268 138.217 89.3303 138.637 87.5576Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.144241"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default BranchMange;
